import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchTemplates = ({ type, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'templates/v2',
        params: {
            type,
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createTemplate = ({ type, name, description, resource_id, fields, children, options }) => {
    return AjaxService({
        method: 'post',
        url: `templates/${type}`,
        data: {
            name,
            description,
            resource_id,
            fields,
            children,
            options
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchTemplate = templateId => {
    return AjaxService({
        method: 'get',
        url: `templates/${templateId}`
    })
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const updateTemplate = (templateId, { name, description }) => {
    return AjaxService({
        method: 'put',
        url: `templates/${templateId}`,
        data: {
            name,
            description
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeTemplate = templateId => {
    return AjaxService({
        method: 'delete',
        url: `templates/${templateId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchPublicTemplate = (templateId, token) => {
    return AjaxService({
        method: 'get',
        url: `templates/public/${templateId}`
    }, false, token)
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const addPublicTemplate = (templateId, name) => {
    return AjaxService({
        method: 'post',
        url: `templates/addTemplate`,
        data: {
            resource_id: templateId,
            name
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchResourceChildrenForTemplate = (type, resource_id) => {
    return AjaxService({
        method: 'get',
        url: 'templates/resource_children',
        params: {
            type,
            resource_id
        }
    })
    .then(response => response.data?.resources)
    .catch(handleServerError);
}
